import "./AccordionChildren.scss";
import { Typography } from "../../ui";

function AccordionChildren({
  titleChildren,
  shownChildren,
  indexChildren,
  subItems,
  categories
}) {
  return (
    <div className="AccordionChildren">
      <div className="accordion-children">
        <Typography className="name" variant="body1" color="dark-gray">
          {titleChildren}
        </Typography>
        <div className="items">
          <div className="item"></div>
          <div className="item">
            <Typography variant="body1" color="dark-gray">
              {shownChildren}
            </Typography>
          </div>
          {/* <div className="item">
            <Typography variant="body1" color="dark-gray">
              {segmentChildren}
            </Typography>
          </div> */}
          <div className="item">
            <Typography variant="body1" color="blue">
              {indexChildren}
            </Typography>
          </div>
        </div>
      </div>

      {subItems && (
        categories.map((item, index) => (
          <div key={index} className="accordion-sub__children">
            <div className="name">
              <Typography variant="body1" color="dark-gray">
                {item.label}
              </Typography>
            </div>
            <div className="items">
              <div className="item"></div>
              <div className="item">
                <Typography variant="body1" color="dark-gray">
                  {item.value}
                </Typography>
              </div>
              <div className="item">
                <Typography variant="body1" color="blue">
                {item.ai + "%"}
                </Typography>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default AccordionChildren;
